import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Siparisler from './pages/Siparisler';
import SiparisOlustur from './pages/SiparisOlustur';
import SiparisDetay from './pages/SiparisDetay';
import Urunler from './pages/Urunler';
import UrunOlustur from './pages/UrunOlustur';
import Musteriler from './pages/Musteriler';
import MusteriDetay from './pages/MusteriDetay';
import Depolar from './pages/Depolar';
import DepoDetay from './pages/DepoDetay';
import Komisyonlar from './pages/Komisyonlar';
import Odemeler from './pages/Odemeler';
import Raporlar from './pages/Raporlar';
import Kullanicilar from './pages/Kullanicilar';
import Firmalar from './pages/Firmalar';
import Arama from './pages/Arama';
import OdemeFormu from './pages/OdemeFormu';
import KargoYonetimi from './pages/KargoYonetimi';
import EtkenMaddeler from './pages/EtkenMaddeler';
import KKOdemeSayfasi from './pages/KKOdemeSayfasi';
import FaturaliHavaleSayfasi from './pages/FaturaliHavaleSayfasi';

function PrivateRoute({ children, roller }) {
  const { user, profil, loading } = useAuth();
  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#0f1117',color:'#fff',fontSize:18}}>Yükleniyor...</div>;
  if (!user) return <Navigate to="/giris" replace />;
  if (roller && profil && !roller.includes(profil.rol)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* PUBLIC — giriş yapmadan açılır */}
          <Route path="/odeme/:siparisNo" element={<OdemeFormu />} />
          <Route path="/kk-odeme/:siparisNo" element={<KKOdemeSayfasi />} />
          <Route path="/faturali-havale/:siparisNo" element={<FaturaliHavaleSayfasi />} />

          <Route path="/giris" element={<Login />} />
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="siparisler" element={<Siparisler />} />
            <Route path="siparisler/yeni" element={<PrivateRoute roller={['super_admin','admin','temsilci']}><SiparisOlustur /></PrivateRoute>} />
            <Route path="siparisler/:id" element={<SiparisDetay />} />
            <Route path="urunler" element={<Urunler />} />
            <Route path="urunler/yeni" element={<PrivateRoute roller={['super_admin','admin']}><UrunOlustur /></PrivateRoute>} />
            <Route path="urunler/:id" element={<PrivateRoute roller={['super_admin','admin']}><UrunOlustur /></PrivateRoute>} />
            <Route path="musteriler" element={<PrivateRoute roller={['super_admin','admin','temsilci']}><Musteriler /></PrivateRoute>} />
            <Route path="musteriler/:id" element={<PrivateRoute roller={['super_admin','admin','temsilci']}><MusteriDetay /></PrivateRoute>} />
            <Route path="depolar" element={<Depolar />} />
            <Route path="depolar/:id" element={<DepoDetay />} />
            <Route path="komisyonlar" element={<PrivateRoute roller={['super_admin','admin','temsilci']}><Komisyonlar /></PrivateRoute>} />
            <Route path="odemeler" element={<PrivateRoute roller={['super_admin','admin','temsilci']}><Odemeler /></PrivateRoute>} />
            <Route path="raporlar" element={<PrivateRoute roller={['super_admin','admin']}><Raporlar /></PrivateRoute>} />
            <Route path="kullanicilar" element={<PrivateRoute roller={['super_admin','admin']}><Kullanicilar /></PrivateRoute>} />
            <Route path="firmalar" element={<PrivateRoute roller={['super_admin','admin']}><Firmalar /></PrivateRoute>} />
            <Route path="arama" element={<Arama />} />
            <Route path="kargo" element={<PrivateRoute roller={['super_admin','admin']}><KargoYonetimi /></PrivateRoute>} />
            <Route path="etken-maddeler" element={<PrivateRoute roller={['super_admin','admin']}><EtkenMaddeler /></PrivateRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
